export default __webpack_public_path__ + "static/media/add-debit-card.ebba994b.jpg";